<!-- Family info - 家庭信息 -->
<template>
  <div class="info-family">
    <h1>Family info</h1>
    <div class="dis-48">
      <div class="dis-24">1. Family information references - who are you thinking of asking?</div>
      <div class="dis-12">If your parents' profession has anything to do with your major selection, please specify</div>
      <div>
        <pre>{{info.parentsJobAffect}}</pre>
      </div>
    </div>
    <div class="dis-48">
      <div class="dis-12">2. Have you had to overcome any personal or professional hardships? If yes, please describe in detail</div>
      <div>
        <pre>{{info.conquerDifficultyUndergo}}</pre>
      </div>
    </div>
    <div class="dis-48">
      <div class="dis-12">3. Have you ever undertaken paid employment during your studies (during term time)? If yes, please describe in detail</div>
      <div>
        <pre>{{info.workExperience}}</pre>
      </div>
    </div>
    <div class="dis-48">
      <div class="dis-12">4. Describe at least one 'defining moment' in your life. If yes, please describe in detail</div>
      <div>
        <pre>{{info.crisis}}</pre>
      </div>
    </div>
    <div class="dis-48">
      <div class="dis-12">5. Experiences, books, conversations, that have impacted you and made you think about your current path or future goals</div>
      <div class="dis-24" v-for="(item,index) in info.influenceOneselfUndergos" :key="index">
        <div class="dis-12">Experience {{index+1}}</div>
        <div>
          <pre>{{item}}</pre>
        </div>
      </div>
    </div>
    <div class="dis-48">
      <div class="dis-12">6. What personal qualities do you believe make you unique?</div>
      <div class="dis-24" v-for="(item,index) in info.haveQualitys" :key="index">
        <div class="dis-12">Experience {{index + 1}}</div>
        <div>
          <pre>{{item}}</pre>
        </div>
      </div>
    </div>
    <div class="dis-48">
      <div class="dis-24">7. How would your friends describe you? Provide 3 adjectives</div>
      <div v-for="(item,index) in info.describeYourself" :key="index">
        <ul class="ul-item dis-24">
          <li>
            <div>Adjective</div>
            <div>{{item}}</div>
          </li>
        </ul>
      </div>
    </div>
    <div class="dis-48">
      <div class="dis-24">8. Who are the top 2 people who have impacted or influenced you? Why? (you don't have to know them personally)</div>
      <div class="dis-24" v-for="(item,index) in info.affectHumans" :key="index">
        <div class="dis-12">Person and why？</div>
        <div>
          <pre>{{item.description}}</pre>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { infoQueryFamily } from '@/api/mentee'
export default {
  name: 'mentee-info-family',
  components: {},
  data () {
    return {
      info: {}
    }
  },
  computed: {},
  mounted () {
    this.getInfo()
  },
  methods: {
    getInfo () {
      let param = {
        num: this.$route.params.id
      }
      infoQueryFamily(param).then(res => {
        let data = res.data.model || {}
        this.info = Object.assign({}, data)
      }).catch(error => {
        this.$zlr_message(error.message, 'error')
      })
    }
  }
}
</script>
<style lang='less' scoped>
</style>
